<template>
  <ul class="tab">
    <li
      class="tab-item"
      :style="{ width: `${itemWidth}px` }"
      v-for="item in list"
      :key="item.value"
      :class="{ active: current === item.value }"
      @click="$emit('item-click', item.value)"
    >
      <!-- 有to的情况下执行跳转操作 -->
      <lr-link :to="item.to" v-if="item.to">
        {{ item.name }}
      </lr-link>
      <!-- 没有to的情况下抛出点击事件 -->
      <a v-else>{{ item.name }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [
        {
          name: '',
          value: '',
          to: '',
        },
      ],
    },

    itemWidth: { type: [Number, String], default: 146 },
    current: String,
  },
};
</script>

<style lang="scss" scoped>
.tab {
  display: flex;
  height: 42px;
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;

  &-item {
    position: relative;
    list-style: none;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border: 1px solid #e8e8e8;
    color: #252529;
    background: #f6f6f6;
    cursor: pointer;
    box-sizing: border-box;

    &:not(:last-of-type) {
      border-right: none;
    }

    > a {
      display: block;
      width: 100%;
      height: 100%;
    }

    &.active,
    &:hover {
      border-bottom: 1px solid #fff;
      > a {
        background: #fff;
        color: #417ff9;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        display: block;
        width: 48px;
        height: 3px;
        left: 50%;
        margin-left: -24px;
        background: #417ff9;
      }
    }
  }
}
</style>